import { MessageContain } from './Styled';
import React, { useRef, useEffect, useState } from 'react';

import Text from '../../Text';

export const SnackDisplay = ({ lastUpdated, message, onMessageHide }) => {
  const [isOpen, setOpen] = useState(true);
  const timerRef = useRef();

  useEffect(() => {
    if (!message) return;

    clearTimeout(timerRef.current);
    setOpen(true);
    
    const afterShow = () => {
      timerRef.current = setTimeout(() => {
        setOpen(false);
        onMessageHide && onMessageHide();
        clearTimeout(timerRef.current);
      }, 1000)
    }

    timerRef.current = setTimeout(afterShow, 2000);

    return () => {
      clearTimeout(timerRef.current);
    }
  }, [ message, lastUpdated ]);

  if (!message) return null;

  return (
    <MessageContain isOpen={isOpen}>
      <Text.Default color="#fff" size="16px">
        {message}
      </Text.Default>
    </MessageContain>
  );
};

export default SnackDisplay;
